const SUPPORTED_OUTPUT_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp'])

export default async function getCroppedImg(imageSrc, crop, options = {}) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const x = Math.round(crop.x)
  const y = Math.round(crop.y)
  const width = Math.round(crop.width)
  const height = Math.round(crop.height)
  const mimeType = SUPPORTED_OUTPUT_TYPES.has(options.mimeType)
    ? options.mimeType
    : 'image/jpeg'

  if (!ctx || !width || !height) {
    throw new Error('Failed to crop image')
  }

  canvas.width = width
  canvas.height = height
  ctx.imageSmoothingEnabled = true
  ctx.imageSmoothingQuality = 'high'

  ctx.drawImage(
    image,
    x,
    y,
    width,
    height,
    0,
    0,
    width,
    height
  )

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error('Failed to export cropped image'))
        return
      }

      resolve(blob)
    }, mimeType, 0.92)
  })

  return new File([blob], buildFileName(options.fileName, mimeType), {
    type: mimeType,
    lastModified: Date.now()
  })
}

function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.decoding = 'async'
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.src = url
  })
}

function buildFileName(fileName, mimeType) {
  const extensionByType = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp'
  }

  const extension = extensionByType[mimeType] || 'jpg'
  const baseName = fileName ? fileName.replace(/\.[^.]+$/, '') : 'avatar'

  return `${baseName}.${extension}`
}
